import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React from 'react';
import { Card } from '@/components/ui/card';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';
import { OrigemData } from '../utils/mockData';

import * as Icons from 'lucide-react';

interface ChartOrigemProps {
  data: OrigemData[];
}

export function ChartOrigem({ data }: ChartOrigemProps) {
  useLanguage();
  const chartData = data.map(d => ({ name: d.nome, value: d.valor }));
  const total = data.reduce((sum, d) => sum + d.valor, 0);
  
  return (
    <Card className="border border-[#E5E7EB] rounded-[14px] p-6">
      <div className="mb-4">
        <h3 className="text-[15px] font-semibold text-[#101828]">{translateInterfaceText("Origem dos Leads")}</h3>
        <p className="text-[12px] text-[#667085] mt-1">{translateInterfaceText("Distribuição por fonte de tráfego")}</p>
      </div>
      
      <div className="flex items-center gap-6">
        {/* Gráfico Donut */}
        <div className="w-40 h-40">
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={chartData}
                cx="50%"
                cy="50%"
                innerRadius={50}
                outerRadius={70}
                paddingAngle={2}
                dataKey="value"
              >
                {data.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.cor} />
                ))}
              </Pie>
              <Tooltip
                contentStyle={{
                  backgroundColor: '#FFFFFF',
                  border: '1px solid #E5E7EB',
                  borderRadius: '8px',
                  fontSize: '12px'
                }}
              />
            </PieChart>
          </ResponsiveContainer>
        </div>
        
        {/* Ranking */}
        <div className="flex-1 space-y-3">
          {data.map((origem, index) => {
            const percentage = ((origem.valor / total) * 100).toFixed(1);
            
            return (
              <div key={index} className="flex items-center gap-3">
                <div 
                  className="w-8 h-8 rounded-full flex items-center justify-center shrink-0"
                  style={{ backgroundColor: `${origem.cor}15` }}
                >
                  <div className="w-3 h-3 rounded-full" style={{ backgroundColor: origem.cor }}></div>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between mb-1">
                    <span className="text-[13px] font-medium text-[#101828]">{origem.nome}</span>
                    <span className="text-[12px] text-[#667085]">{percentage}%</span>
                  </div>
                  <div className="h-1.5 bg-[#F3F4F6] rounded-full overflow-hidden">
                    <div 
                      className="h-full rounded-full transition-all duration-500"
                      style={{ 
                        width: `${percentage}%`,
                        backgroundColor: origem.cor
                      }}
                    ></div>
                  </div>
                </div>
                <span className="text-[14px] font-semibold text-[#101828] w-12 text-right">
                  {origem.valor}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </Card>
  );
}
